import {createSelector} from "@reduxjs/toolkit";
import {CommonState} from "..";
import {InitialState} from "./types";
import { IGroup } from "../../common/group";
import { Course } from "../../common/course";
import {selectCourseById, selectCourses} from "../course/selectors";

export const selectGroupReducer = (state: CommonState): InitialState => state.group;
export const selectGroups = createSelector(
    [
        (state: CommonState) => selectGroupReducer(state),
    ],
    (groupState: InitialState) => {
        return Object.values(groupState.groups);
    }
);

export const selectRootGroup = createSelector(
    [
        (state: CommonState) => selectGroups(state),
    ],
    (groups: IGroup[]) => {
        return groups.find(group => group.isRoot);
    }
); 

export const selectGroupById = createSelector(
    [
        (state: CommonState) => selectGroups(state),
        (state: CommonState, id: IGroup['id']) => id,
    ],
    (groups: IGroup[], id: IGroup['id']) => groups.find(group => group.id === id),
);

export const selectGroupCourses = createSelector([
    (state: CommonState) => state,
    (state: CommonState, {groupId}: {groupId: IGroup['id']}) => selectGroupById(state, String(groupId)), 
], (state, group) => {
    return group?.courses?.map((courseId: Course['id']) => selectCourseById(state, courseId))
});

export const selectNotInGroupCourses = createSelector([
    (state: CommonState) => state,
    (state: CommonState, {groupId}: {groupId: IGroup['id']}) => selectGroupById(state, String(groupId)),
], (state, group) => {
    const allCourses= selectCourses(state)
    const coursesInGroup = group?.courses?.reduce((result, current) => {
        //@ts-expect-error
        result[current] = 1;
        return result;
    }, {});
    if (!coursesInGroup) {
        return [];
    }
    //@ts-expect-error
    return allCourses?.filter(course => !coursesInGroup[course.id]);
});